// extracted by mini-css-extract-plugin
export default {"removedText":"TeamMemberList_removedText__Aox8k","removedAvatar":"TeamMemberList_removedAvatar__Ja34f"};